import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { AppLink } from "@/components/common/app-link";
import { q } from "@/data/queries";
import { projectPath } from "@/lib/nav";

export const Route = createFileRoute("/p/$project/mail/")({
  component: MailIndexPage,
});

/**
 * The empty state of the thread pane. It points at the threads with real
 * bodies, because those are the ones worth opening.
 */
function MailIndexPage() {
  const { project } = Route.useParams();
  const { data: threads } = useSuspenseQuery(q.mailThreads());
  const authored = threads.items.filter((thread) => !thread.id.startsWith("thr_acc_"));

  return (
    <div className="flex min-h-0 flex-1 items-center justify-center p-8">
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <h1 className="text-[15px] font-semibold">Mail, behind one API</h1>
        <p className="text-[13px] leading-[1.55] text-muted-foreground">
          Gmail and Outlook over their own APIs, iCloud, Fastmail, Zoho and anything
          else over IMAP, all through the same endpoints. Open a thread with a full
          body:
        </p>
        <ul className="flex w-full flex-col gap-1.5">
          {authored.slice(0, 5).map((thread) => (
            <li key={thread.id}>
              <AppLink
                to={projectPath(project, `/mail/${thread.id}`)}
                className="block truncate rounded-md border px-3 py-2 text-left text-[13px] transition-colors hover:bg-accent/50 focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:outline-none"
              >
                {thread.subject}
              </AppLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
